import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { DEFAULT_PAGE_META } from "@/vike/pageMetadata";

/** Legacy description helper for pages not yet on Vike head metadata. */
export default function MetaComponent({ meta }) {
  if (!meta?.description) return null;

  return (
    <HelmetProvider>
      <Helmet>
        <meta
          name="description"
          content={meta.description || DEFAULT_PAGE_META.description}
        />
      </Helmet>
    </HelmetProvider>
  );
}
